<!--/*
* @name: 新增报警
* @description: 新增报警
* @author: zefeng(zefeng.chen@shengyc.com)
* @Date: 2020-02-17 10:42:18
* @LastEditTime: 2020-02-17 10:42:18
*/-->

<template>
    <div id="add_container" ref="main">
        <nav-back :headTitle="headTitle" :bg="'#3766E1'" color="#FFFFFF" router="/warmSearchScreen">
        </nav-back>
        <div class="feedback_main" :class="is_Safari() ? 'b100' : null" v-myloading="loading"> 
            <van-form @submit="onSubmit" :show-error="false" ref="formbox"> 
                <div class="form-wrap">
                     <!-- 设备编号 -->
                    <van-field
                        v-model="params.equipmentNames" 
                        required
                        name="picker"
                        label="报警设备"
                        placeholder="请选择"
                        is-link
                        @focus="selectStopBlur"
                        @click="$_selectEquipment"
                    />   
                    <!-- 报警级别 -->
                    <van-field 
                        required
                        name="radio"
                    >
                        <template #label> 
                            <span>报警级别</span>
                            <span class="second-label">(阈值报警达到某个级别时才推送消息)</span>
                        </template> 
                        <template #input>
                            <van-checkbox-group v-model="params.warningLevel" >
                                <van-checkbox class="mb-10" :name="1">高</van-checkbox>
                                <van-checkbox class="mb-10" :name="2">中</van-checkbox>
                                <van-checkbox :name="3">低</van-checkbox>
                            </van-checkbox-group>
                        </template>
                    </van-field> 
                    <!-- 系统人员推送方式 -->
                    <van-field
                        v-model="params.systemStaffName"  
                        name="picker"
                        label="系统人员推送"
                        placeholder="请选择"
                        is-link
                        @focus="selectStopBlur"
                        @click.stop="$_addPushPerson"
                    />   
                    <!-- 系统人员推送方式 -->
                    <van-field  
                        name="radio"
                        label="系统推送方式"
                    > 
                        <template #input>
                            <van-checkbox-group v-model="params.systemStaffPushType">
                                <van-checkbox class="mb-10" :name="1">邮件</van-checkbox>
                                <van-checkbox :name="0">短信</van-checkbox> 
                            </van-checkbox-group>
                        </template>
                    </van-field> 
                    <!-- 其他人员推送 --> 
                    <div class="other-person">
                        <div class="other-person-title">
                            <div class="label-content">
                                <span>其他人员推送</span>
                                <span class="second-label">(推送给指定手机或邮箱)</span>
                            </div> 
                            <div class="label-add" @click="$_addPerson">添加</div>
                        </div>
                        <div class="other-person-content">
                            <van-tag
                                color="#F5F5F5"
                                text-color="#333333"
                                v-for="(checkItem, idx) in params.otherStaff"
                                :key="checkItem.id"
                            >
                                {{ checkItem.value }}
                                <img
                                    src="@/assets/images/icon_delete_tag.png"
                                    class="icon-close"
                                    alt=""
                                    @click="closeItem(idx)"
                                />
                            </van-tag>
                        </div>
                    </div>
                    <div class="card-open">
                        <div class="card-open-left">
                            是否开启
                        </div>
                        <div class="card-open-right">
                            <van-switch 
                                @click.stop="" 
                                v-model="params.pushStatus" 
                                active-color="#2AC958" 
                                inactive-color="#CCCCCC"  
                            />
                        </div>
                    </div>
                </div>
                <!-- <div class="bottom-btn"> -->
                <div class="bottom-btn">
                    <van-button class="submit-btn" native-type="submit"> 
                        <span>提交</span>
                    </van-button>
                </div>
            </van-form>

        </div> 
        <van-popup
            v-model="showPopup"
            position="right"
            :style="{ height: '100%', width: '85%' }"
            @click-overlay="cancel"
            > 
             <person-choose @save="savePullPerson" :assistantList="params.systemStaffList"></person-choose>
            </van-popup>
    </div>
</template>
<script> 
import { addWarningSetting, getWarningSettings } from '@/service/getData'
import { Toast } from 'vant'
import { _handleMedia } from '@/config/Upload'
import NavBack from '@/components/NavBack/index.vue'
import personChoose from './person-choose/index.vue' 
import { mapGetters } from 'vuex'
export default {
    name: 'FeedbackScreen',
    components: { 
        NavBack,
        personChoose
    },
    props: { 
    }, 
    computed: {
        ...mapGetters({
            warmingInfo: 'warmingInfo', 
        })
    },
    data() {
        return {
            // 表单数据
            params: { 
                equipmentInfoId: [], // 设备id 
                equipmentNames: '', // 设备名称 
                warningLevel: [], // 级别
                systemStaffPushType: [], // 推送方式
                pushStatus: '',
                otherStaff: [],
                systemStaffName: '',
                systemStaffList: [] // 人员
            },
            // 选择
            cacheParams: {},    
            saveFlag: true, 
            loading: false,
            showPopup: false, // 显示框 
            headTitle: '新增报警提醒'
        }
    }, 
    created() {
        this.init()
    },  
    methods: {  
        selectStopBlur () {
            document.activeElement.blur()
        },
        // 保存人员
        savePullPerson (systemStaffList) {
            this.$set(this.params, 'systemStaffList', systemStaffList)  
            this.showPopup = false
            let systemStaffName = []
            systemStaffList && systemStaffList.forEach(item => {
                systemStaffName.push(item.name)
            })
            this.params.systemStaffName = systemStaffName.join('；')
            this.$store.commit('SET_WARMING_INFO', this.params)
        },
        $_addPushPerson () {  
            this.showPopup = true
        },
        // 人员选择弹框
        cancel () {
            this.params.systemStaffList = []
        },
        confirm () {},
        // 取消勾选
        closeItem(index) {
            this.params.otherStaff.splice(index, 1) 
        },
       // 初始化
        async init() {  
            // 从缓存中取值
            if (this.warmingInfo) {
                Object.keys(this.warmingInfo).forEach(key => {
                    this.$set(this.params, key, this.warmingInfo[key]) 
                })
            } 
            // 保存选择设备带过来的信息 
            if (this.warmingInfo.equipmentInfo) {
                // 设备选择
                let equipmentInfo = this.warmingInfo.equipmentInfo
                this.params.equipmentInfoId = []
                let equipmentNames = []
                equipmentInfo.forEach(item => {
                    this.params.equipmentInfoId.push(item.id)
                    equipmentNames.push(item.name)
                })
                this.params.equipmentNames = equipmentNames.join(';')
            }  
            // 编辑
            if (this.$route.query.id || this.warmingInfo.id) {
                this.headTitle = '编辑报警提醒'
                window.document.title = '编辑报警提醒'  
            }  
            if (this.$route.query.id) {
                this.params.id = this.$route.query.id
                this.$_getData(this.params.id)
            }
        },
        // 获取详情
        $_getData(id) { 
            this.loading = true
           //盛云宝
            getWarningSettings({ 
                pageNum: 1,
                pageSize: 10, 
                id
            }).then((res) => {
                this.loading = false 
                if (res && res.result && res.result.length === 1) { 
                    let warningData = res.result[0] 
                    this.params.equipmentInfo = warningData.equipmentInfo
                    this.params.equipmentInfoId = []
                    let equipmentNames = []
                    warningData.equipmentInfo.forEach(item => {
                        this.params.equipmentInfoId.push(item.id)
                        equipmentNames.push(item.name)
                    })
                    this.params.equipmentNames = equipmentNames.join(';')
                    this.params.pushStatus = warningData.pushStatus === 0 ? true : false
                    warningData.otherStaffEmail && warningData.otherStaffEmail.forEach(item => {
                        this.params.otherStaff.push({
                            method: '邮箱', value: item
                        })
                    })
                    warningData.otherStaffPhone && warningData.otherStaffPhone.forEach(item => {
                        this.params.otherStaff.push({
                            method: '手机', value: item
                        })
                    })
                    this.savePullPerson(warningData.pushSystemStaff)
                    this.$set(this.params, 'warningLevel', warningData.warningLevel)
                    this.$set(this.params, 'systemStaffPushType', warningData.systemStaffPushType || []) 
                }
            }).catch(err => {
                this.loading = false
            })
        },  
        // 表单提交
        async onSubmit() {
            if (!(this.params.equipmentInfoId && this.params.equipmentInfoId.length > 0)) {
                Toast('请选择报警设备');
                return
            } 
            if (!(this.params.warningLevel && this.params.warningLevel.length > 0)) {
                Toast('请选择报警级别');
                return
            } 
            Toast.loading({
                message: '正在提交...',
                forbidClick: true,
                duration: 0
            }) 
            this.sendRequest()
        },
        sendRequest() { 
            let requestParams = { 
                equipmentInfoId: this.params.equipmentInfoId,   
                id: this.params.id,
                systemStaffPushType: this.params.systemStaffPushType,
                pushStatus: this.params.pushStatus ? 0 : 1, 
                warningLevel: this.params.warningLevel,
                otherStaffEmail: [], 
                otherStaffPhone: [],
                systemStaffUid: [], 
            }  
            this.params.systemStaffList && this.params.systemStaffList.forEach(item => {
                requestParams.systemStaffUid.push(item.uid)
            }) 
            this.params.otherStaff && this.params.otherStaff.forEach(item => {
                if (item.method === '手机') {
                    requestParams.otherStaffPhone.push(item.value)
                }
                if (item.method === '邮箱') {
                    requestParams.otherStaffEmail.push(item.value)
                }
            })  
            addWarningSetting(requestParams)
                .then(res => { 
                    Toast.clear()
                    Toast('提交成功!') 
                    // 清空缓存
                    this.$store.commit('SET_WARMING_INFO', {})
                    this.$router.push({
                        path: '/warmSearchScreen' 
                    })
                })
                .catch(err => {
                    // Toast.clear()
                })
        },
        // 点击选择人员
        $_addPerson() {
            this.$store.commit('SET_WARMING_INFO', this.params)
            this.$router.push({
                path: '/addWarmPerson',
                query: {
                    from: '/addWarm',
                }
            })
        },
        //点击选择设备
        $_selectEquipment() {
            this.$store.commit('SET_WARMING_INFO', this.params)
            //oem员工先去选客户
            this.$router.push({
                path: '/equitmentMultSearchScreen',
                query: {
                    from: '/addWarm', 
                }
            })
        },     
        is_Safari() {
            var ua = navigator.userAgent.toLocaleLowerCase()

            if (/safari/.test(ua) && !/chrome/.test(ua)) {
                return true
            } else {
                return false
            }
        }, 
    }
}
</script>

<style lang="scss">
@import '@/assets/style/mixin';
::-webkit-scrollbar {
    display: none;
}
.mb-10{
    margin-bottom: vw(10);
}
#add_container {
    @include fja(flex-start, flex-start);
    height: 100%;
    width: 100vw;
    flex-direction: column;
    font-weight: 400;
    font-family: PingFang SC;
    .b100 {
        padding-bottom: vw(100);
    }
    position: relative;
    .van-field__control {
        text-overflow: ellipsis;
        word-break: break-all;
        overflow: hidden;
        padding-right: vw(60);
    }
    .van-tag {
        margin-right: vw(8);
        margin-bottom: vw(16);
        border-radius: vw(13);
        height: vw(26);
        padding: 0 vw(6) 0 vw(10);
        font-size: vw(12);
        .icon-close {
            width: vw(24);
            height: vw(24);
        }
    }
    .feedback_main {
        overflow-y: scroll;
        overflow-x: hidden;
        flex: 1;
        -webkit-overflow-scrolling: touch; //实现苹果手机的滚动回弹效果
        background: #f2f2f2;
        width: 100%;
        padding-bottom: vw(74); 
        .form-wrap{ 
            background: white;
            padding: 10px 15px;
            .form-title{
                border: 1px solid #EEEEEE;
                font-size: vw(14);
                color: #333333;

            }
        }
        .other-person{
            .other-person-title{
                display: flex;
                padding: vw(10) 0;
                .label-content{
                    flex: 1;
                }
                .label-add{
                    color: #3D7BED;
                }
            }
            .other-person-content{

            }
        }
        .card-open{
            display: flex;
            align-items: center;
            padding: vw(10) 0;
            margin-bottom: vw(11);
            .card-open-left{
                flex: 1;
                font-size: vw(14);
                color: #333333;
            }
            .card-open-right{ 
                .van-switch{
                    font-size: vw(18);
                    border-color: white;
                    height: vw(22); 
                    width: vw(40);  
                }
                .van-switch__node {
                    top: vw(2);
                    left: vw(2);
                }
            }
        }
        .van-form {
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            padding: 0; 
            .van-cell--required {
                .van-field__label {
                    padding-left: vw(10);
                    width: 100%; 
                }
                &::before {
                    left: 0;
                }
            } 
            .second-label{
                color: #999999;
                margin-left: vw(10);
            }
            .van-cell.van-field {
                font-size: vw(15);
                display: flex;
                flex-direction: column;
                padding: 0;
                margin-bottom: 10px;
                .van-field__label {
                    margin-bottom: vw(8);
                    color: #333;
                    font-size: vw(14);
                    width: 100%;  
                }
                .van-cell__right-icon{
                    position: absolute;
                    right: 0;
                    bottom: vw(20);
                }
                .van-field__value {
                    font-size: vw(13);
                    .van-field__body {
                        width: 100%;
                        border-bottom: vw(1) solid #eee;
                        padding-bottom: vw(15);
                    }
                }
                &::after {
                    display: none;
                }
            }
            // 设备编号
            .form_equipmentCode {
                position: relative;
                .van-field__control {
                    padding-right: vw(100);
                }
                .van-icon.van-icon-clear.van-field__clear {
                    position: absolute;
                    right: vw(85);
                    bottom: vw(11);
                    z-index: 50;
                }
                .select {
                    position: absolute;
                    right: vw(61);
                    bottom: vw(14);
                    // width: vw(30);
                    height: vw(30);
                    line-height: vw(30);
                    display: block;
                    z-index: 50;
                    color: #3d7bed;
                }
            }    
            // 提交
            .bottom-btn {
                position: absolute;
                z-index: 10;
                bottom: 0;
                @include fja(center, center);
                width: 100%;
                background: #ffffff;
                padding: vw(10) vw(16);
                padding-top: vw(10);
                .submit-btn {
                    height: vw(44);
                    width: 100%;
                    background: #3766e1;
                    font-size: vw(16);
                    color: #ffffff;
                    border-radius: vw(4);
                }
            }
        }
    } 
}
</style>
